import axios from "axios";
import { authorizationAxios } from "axios/authorizationAxios";
import { BASE_URL } from "constants/BASE_URL";
import { useQuery, useMutation } from "react-query";

export const useDeleteFlightImage = () => {
  async function deleteFlightImage(values) {
    const res = await authorizationAxios.delete(
      `${BASE_URL}/api/heli-partners/flight-images/`,
      {
        data: {
          uuid: values,
        },
      }
    );
    return res;
  }

  const deleteFlightImageMutation = useMutation(deleteFlightImage);

  return { deleteFlightImageMutation };
};
